import { defineAction, object, string, type ActionDefinition } from '~/prix'
import { appSebraeAttendanceExpression } from '~/packages/appSebrae/stats/appSebraeAttendanceStats.definition'
import agentPolygonSmartMappingAction from './agentPolygonSmartMapping.action.json' assert { type: 'json' }

const agentPolygonSmartMappingDefinition = defineAction({
  ...(agentPolygonSmartMappingAction as ActionDefinition<'nodejs20'>),
  input: object({
    agentCpf: string(),
    startDate: string().isOptional(),
    endDate: string().isOptional(),
    cacheKey: string().isOptional(),
    filter: appSebraeAttendanceExpression.isOptional(),
  }),
  output: object<any>({}),
  cache: () => {
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24,
        expirationMsForUpdate: 1000 * 60 * 30,
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24,
        expirationMsForUpdate: 1000 * 60 * 30,
      },
    }
  },
})

export default agentPolygonSmartMappingDefinition
